module.exports = __webpack_public_path__ + "img/premiation-11-viagem-disney-honda-civic.caa32e95.png";